import { formatInTimeZone } from "date-fns-tz";
import enIN from "date-fns/locale/en-IN";
import useEventDetails from "./useEventDetails";

export default function formatTime(inputDate: string) {
  const { formattedTimeZone } = useEventDetails();
  const time = formatInTimeZone(
    inputDate,
    process.env.EVENT_TIME_ZONE_NAME,
    "h:mm a",
    {
      locale: enIN,
    }
  );

  return `${time} ${formattedTimeZone}`;
}
